/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/structure/body/body_styles';



/* ========== ~~~~~~~~~~ STRUCTURE : BODY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Body = (props) => {
    return (
        <article id={`body`} className={`structure ${props.classes.body}`}>
            {props.children}
        </article>
    );
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Body);
